<template>
    <div class="container flex flex-wrap">
        <div class="w-1/3">
            <div class="font-bold">
                General Info:
            </div>
            <div>Total questions: {{ fullTest.questionCount }}</div>
            <div>Current question: {{ fullTest.currentQuestionNumber }}</div>
            <div v-if="fullTest.completed">
                <div>Final percentage: {{ (fullTest.finalPercentage * 100).toFixed(2) }}%</div>
            </div>
            <div v-else>
                Final percentage: N/A
            </div>
            <div v-if="fullTest.expirationDate">
                <div>Expiration date: {{ fullTest.expirationDate | formatShortDate }}</div>
            </div>
            <div v-else>
                Expiration date: N/A
            </div>
        </div>
        <div class="w-1/3" v-if="fullTest.licenseSections.length > 0">
            <div class="font-bold">
                License Sections:
            </div>
            <div v-for="license in fullTest.licenseSections" :key="license">
                {{ license }}
            </div>
        </div>
        <div class="w-1/3">
            <div class="font-bold">
                Question Breakdown:
            </div>
            <div v-for="section in fullTest.sectionSummaryAsList" :key="section">
                {{ section }}
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

  export default {
    parent: true,
    data() {
        return {
            fullTest: null,
            loading: true
        };
    },
    props: {
      testInfo: {
        type: Object,
        default: () => {},
      },
    },
    mounted() {
         this.getTestResults(this.testInfo.id);
     },
     methods: {
         async getTestResults(id) {
             this.loading = true;
           const { data } = await axios.get(`/api/taken-tests-report/${id}`);
             this.fullTest = data;
             this.loading = false;
         },
     }

  };
</script>